import { useEffect, useRef, useState } from "react";

const MOBILE_BREAKPOINT = 768;
const DEBOUNCE_MS = 150;

export const useIsMobile = (breakpoint = MOBILE_BREAKPOINT): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(
    window.innerWidth <= breakpoint,
  );
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    let mounted = true;

    const handleResize = () => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        if (mounted) {
          setIsMobile(window.innerWidth <= breakpoint);
        }
      }, DEBOUNCE_MS);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      mounted = false;
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutRef.current);
    };
  }, [breakpoint]);

  return isMobile;
};
